import type { StreamSourceKind } from "@tih/shared";
import { streamPlaceholder, type StreamForm } from "../../lib/event-stream-form";

type Props = {
  form: StreamForm;
  onChange: (next: StreamForm) => void;
  disabled?: boolean;
  hint?: string;
};

export function EventStreamFields({ form, onChange, disabled, hint }: Props) {
  function set<K extends keyof StreamForm>(key: K, value: StreamForm[K]) {
    onChange({ ...form, [key]: value });
  }

  return (
    <div className="admin-live-grid">
      <label>
        <span>Source kind</span>
        <select
          value={form.kind}
          onChange={(e) => set("kind", e.target.value as StreamSourceKind)}
          disabled={disabled}
        >
          <option value="youtube">YouTube</option>
          <option value="hls">HLS (.m3u8)</option>
          <option value="mp4">MP4</option>
        </select>
      </label>
      <label className="admin-live-grid-wide">
        <span>Source</span>
        <input
          type="text"
          value={form.src}
          placeholder={streamPlaceholder(form.kind)}
          onChange={(e) => set("src", e.target.value)}
          spellCheck={false}
          disabled={disabled}
        />
      </label>
      <label className="admin-live-grid-wide">
        <span>Subtitle (optional)</span>
        <input
          type="text"
          value={form.subtitle}
          placeholder="Dorothy Ashaba & the Upper Room Band"
          onChange={(e) => set("subtitle", e.target.value)}
          disabled={disabled}
        />
      </label>
      {hint && (
        <p className="admin-live-grid-wide admin-card-foot" style={{ margin: 0 }}>
          {hint}
        </p>
      )}
    </div>
  );
}
